<template>
  <div class="ctable">
    <div class="cble">
      <table>
        <thead>
          <td v-if='hasCk' width='24'>
            <a href="javascript:void(0);" :class='{ "all": All }' @change="allCk" class="ckall">
              全选
              <input type="checkbox" v-model='All' @change="allCk" />
            </a>
          </td>
          <td v-for='i in formKey' :width='i.Wid' :key="i.id">{{ i.name }}</td>
          <td width="80">操作</td>
        </thead>
        <tbody>
          <!-- :key="i.id" -->
          <tr v-for='(i, index) in list' :class='{ "overTime": i.overTime }' :key="index">
            <td v-if='hasCk'>
              <input type="checkbox" v-model='i.checked' @change="outCK" />
            </td>
            <td v-for='(j, indexs) in i.list' :key="indexs">
              <div v-if="j.type == 'content'">
                <Tooltip :tit='ArrLetter(j)'>{{ ArrLetter(j) }}</Tooltip>
              </div>
              <div v-else>
                <Tooltip :tit='j | qData' v-if='j.inObjContent'> </Tooltip>
                <div v-else>{{ j | qData }}</div>
              </div>
            </td>
            <td>
              <slot name='pick' :id='i.id' :other='i.other' :element="i.allQ"></slot>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="loadspin"> <a-spin class="spin" tip="加载中" :spinning="!load" /></div>
      <a-empty description="暂无数据" v-if='total == 0 && load' style="margin-top:100px;" />
    </div>
    <div class="pages" v-if='total > 7'>
      <a-pagination v-model="form.page" show-quick-jumper :total="total" show-less-items :pageSize='form.limit'
        @change='turnpage' />
    </div>
  </div>
</template>
<script>
import { showYuan } from '@/assets/js/formData'
import { dict } from '../book'
import { Tooltip } from 'ant-design-vue'
function rinset(data, key) {
  for (let val in data) {
    if (val == key) {
      return data[val]
    }
    else if (data[val] && typeof data[val] == 'object') {
      return rinset(data[val], key)
    }
  }
}
export default {
  props: {
    backAll: Boolean, //是否全部返回
    hasCk: Boolean, //是否有复选操作框
    getUrl: String,   //接口请求
    query: Object,    //接口另外参数
    formKey: Array, //表头 key 列表key
    ID: String,    //操作ID
    other: Array   //特殊需要返回的数据
  },
  data() {
    return {
      All: false,
      load: false,
      total: 0,
      form: {
        page: 1,
        limit: 10
      },
      list: []
    }
  },
  created() {
    this.turnpage()
  },
  filters: {
    qData(val) {      //类型转换

      switch (val.type) {
        case "String":   //可直接输出的value
          return val.value
        case 'time':      //时间
          return val.value ? val.value.slice(0, 10) : ''
        case 'inTime':  //对象里的时间
          return val.value[val.in] ? val.value[val.in].slice(0, 10) : ''
        case 'obj':     //对象
          return rinset(val.value, val.in)
        case 'doubObj':
          return val.value[val.in[0]] ? val.value[val.in[0]][val.in[1]] : ''
        case 'yuan': //钱
          return showYuan(val.value)
        case 'sort': //案件
          return val.value ? ('案件' + (val.in ? val.value[val.in] : val.value)) : '/'
        case 'action':  //动作
          return val.value == "edit" ? "修改" : (val.value == 'add' ? "新增" : "删除")
        case 'special': //特殊参数
          if (val.value.cause.length > 0)
            return val.value.cause[0].compensation_time ? val.value.cause[0].compensation_time.slice(0, 10) : ''
          else
            return ''
        case 'accuser': //特殊参数
          if (val.value.cause && val.value.cause.length > 0)
            return val.value.cause[0].accuser.title
          else
            return ''
        case 'dict': //案件
          return dict[val.dict][val.value]
        case 'array':
          if (val.value.length) {
            return val.value[0][val.in]
          } else {
            return '/'
          }
      }
    },
  },
  methods: {

    allCk() {   //全选
      this.All = !this.All
      let list = JSON.parse(JSON.stringify(this.list))
      list.map(ele => {
        ele.checked = this.All
      })
      this.list = list
      if (this.All) {
        this.outCK(list)
      } else {
        this.$emit('putCk', [])
      }
    },
    outCK(data) {   //单选
      const ids = this.list.filter(ele => {
        return ele.checked
      }).map(ele => {
        return ele.readId
      })
      this.All = ids.length == this.list.length
      this.$emit('putCk', ids)
    },
    ArrLetter(item) {     //某些需要多个key拼接的方法
      if (item.Array) {
        let letter = ''
        item.Array.filter(ele => { return ele }).map(ele => {
          letter += ele + "："
        })
        return letter.slice(0, -1)
      } else {
        return item.value
      }
    },
    resh() {      //刷新表格
      this.form.page = 1;
      this.All = false;
      this.turnpage()
    },
    byformData(data) {      //重置表单数据 列表
      if (data.length == 0) return []
      else {
        let Name = JSON.parse(JSON.stringify(this.formKey)),
          Arr = []
        data.map((element, index) => {
          Arr.push(     //提取公共id
            {
              overTime: element.overTime,
              readId: element.id,
              id: element[this.ID],
              list: [],
              other: []
            }
          )
          Name.map(ele => {
            Arr[index].list.push({
              dict: ele.dict,
              key: ele.key,     //key
              value: element[ele.key],    //值
              type: ele.type || "String", //格式类型判断 
              in: ele.in,       //二级对象参数
              inObjContent: ele.inObjContent,
              Array: ele.Array ? ele.Array.map(s => {
                return element[s]
              }) : null
            })
          })
          if (this.other) {
            this.other.map(s => {
              Arr[index].other.push(element[s])
            })
          }
        })
        return Arr
      }
    },
    turnpage() {
      this.load = false
      this.$Ajax({
        url: this.getUrl,      //url 
        type: "get",
        data: this.query ? Object.assign(this.query, this.form) : this.form,
        success: (e) => {
          let list = e.list
          if (this.getUrl == 'actionLog/newExecMsg') {      //个别接口下的无奈判断
            list.map(s => {
              s.expand_say = s.expand_data.user + '：' + s.expand_data.content
            })
          }
          if (this.getUrl == 'actionLog/newCauseStepRemind') {
            list.map(s => {
              s.title = s.creator.uname + '：' + s.title
            })
          }
          if (this.getUrl == 'todo/index' && this.query.is_complete == 0) {   //个别接口下的无奈判断
            list.map(s => {
              s.overTime = new Date().getTime() >= new Date(s.remind_time).getTime()
            })
          }
          this.total = e.count
          const nlist = this.byformData(list)
          if (this.backAll) {     //返回所有接口字段
            nlist.map((ele, index) => {
              ele.allQ = list[index]
            })
          }
          this.list = nlist
          // console.log(this.list);
          this.load = true
        }
      })
    }
  }

}
</script>
<style lang="less" scoped>
.loadspin {

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* 移除所有表格分割线 */
// table, thead, tbody, tr, td, th {
//   border: none !important;
// }
.cble {
  padding: 10px 0;
}

.thead {
  background: #1890ff !important;
}

.overTime {
  td {
    color: #f00;
  }
}

.ckall {
  color: #0e2949;
  position: relative;
  cursor: pointer;

  input {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  &:hover {
    color: #1890ff;
  }
}

.ckall.all {
  border-bottom: 1px solid #1890ff;
  display: inline-block;
  color: #1890ff;
}
</style>